(function(root) {
define("global_helper", ["jquery"], function() {
  return (function() {
/**
 * For browsers that don't support object.keys:
 * (http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation)
 */
Object.keys = Object.keys || function(o) {
    var result = [];
    for(var name in o) {
        if (o.hasOwnProperty(name))
          result.push(name);
    }
    return result;
};

/**
 * JS String repeat
 * http://stackoverflow.com/questions/202605/repeat-string-javascript
 */
String.prototype.repeat = function(num) {
    return new Array( num + 1 ).join( this );
};

/**
 * Defines a global helper function. This is accessbile by using global_helper.xxx
 * where xxx is the function you want to access.
 * @module global/global_helper
 */
(function($) {
    var err_title = "Looks like we have some more work to do";
    if(Vspot.oldBrowser) {
        err_title = "You are using an unsupported browser";
    }

    /**
     * global_helper
     * @exports global_helper
     */
    global_helper = Vspot.global_helper =  {
        error_email_subject:    "SignUp.com Client Error",
        error_email_message:    "Page URL:\t#PAGE-URL#\n\nPlease describe what you were doing when the error occurred:\n\n",
        error_dialog_title:     err_title,
        ignore_files:           [
            "yslow-firebug\.js", // If you have yslow installed in firebug, and it barfs... probably because the user has the console open in a tab they aren't viewing
            "pro-market\.net", // Crappy third party JS
            "imrworldwide\.com", // Neilson
            "pinterest\.com", // Pinterest
            "platform\.twitter\.com", // Twitter
            "connect\.facebook\.net", // Facebook
            "cgi-bin\/blockpage\.cgi\?ws-session=", // Websense, a local web filtering technology that some schools use.
            "googleadservices\.com", // Google Ad Services
            "cloudfront\.net", // Some BS service for IE
            "bmi-int-js\/bmi\.js", // Some sort of proxy
            "socialbit\.com", // Possibly shopping comparison plug-in
            "fastfreeconverter\.com", // Converts FLV files
            "qwiklinx\.net", // A search bar
            "blockpage\.cgi", // regex above was not catching this http://10.25.250.4:15871/cgi-bin/blockpage.cgi?ws-session=4078444877
            "api\.teamsnap\.com" // teamsnap api
        ],
        ignore_lines: [
            "tinymce\.min\.js" // ignore errors that come from this file
        ],
        ignore_errors:          [
            "steal\.js.+not completed", // Steal failed to load a file... probably because the user clicked another link mid-page load
            "steal\.production\.js.+not completed", // Steal failed to load a file... probably because the user clicked another link mid-page load
            "Script error\.", // FF, Chrome, Safari third party script violating same origin policy
            "Unterminated string constant", // PWD: IE likes to throw these and it is not clear they really exist. log and ignore.
            "Authentication failed", // No need to throw an error when the authentication fails. Client detects in user-service the need to redirect to login
            "missing hash prefix", // PWD: these come from having an anchor tag in a URL (#foo), angular gets upset that it is not #!
            "ihshprfx" // PWD: yes, the minified version throws a different error
        ],

        get_error_email_link: function() {
            var message = global_helper.error_email_message.replace("#PAGE-URL#", document.URL);
            return "mailto:support@SignUp.com?Subject=" + encodeURIComponent(global_helper.error_email_subject) + "&Body=" + encodeURIComponent(message);
        },

        /*
         * open_error_dialog:
         * Open an error dialog... but only if the error is fatal and one we care to alert the user to.
         * "ignore_files" and "ignore_errors" are arrays of regular expressions to match against.
         */
        open_error_dialog: function(to_log) {

            var show_alert      = true;

            // Check for files to skip
            if( typeof(to_log.error_file) !== "undefined") {
                $.each(global_helper.ignore_files, function(k,v) {
                    var pattern = new RegExp(v, "i");
                    if( pattern.test( to_log.error_file ) !== false ) {
                        // It's a file we don't care about
                        show_alert = false;
                        return false; // Break out of the loop
                    }
                });
            }

            // Check for files to skip, not found in error_file
            if( show_alert && typeof( to_log.error_line ) !== "undefined" && typeof( to_log.error_line ) === "string" ) {
                $.each(global_helper.ignore_lines, function(k,v) {
                    var pattern = new RegExp(v, "i");
                    if( pattern.test( to_log.error_line.toLowerCase() ) !== false ) {
                        // It's a message we don't care about
                        show_alert = false;
                        return false; // Break out of the loop
                    }
                });
            }

            // Check for errors to skip
            if( show_alert && typeof(to_log.error_message) !== "undefined" ) {
                $.each(global_helper.ignore_errors, function(k,v) {
                    var pattern = new RegExp(v, "i");
                    if( pattern.test( to_log.error_message.toLowerCase() ) !== false ) {
                        // It's a message we don't care about
                        show_alert = false;
                        return false; // Break out of the loop
                    }
                });
            }

            if( show_alert ) {
                try {
                    // Get the updated email link
                    $("#error_email_link").attr( "href", global_helper.get_error_email_link() );

                    // Load the error image... if not already loaded
                    if( $('.curious-dog').length === 0 ) {
                        $('<img src="/imgs/resources/curious-dog.png" alt="Curious Dog" class="curious-dog">').appendTo("#error_dialog .error-img");
                    }

                    if(Vspot.oldBrowser) {
                        $("#old_browser_error").show();
                        $("#supported_browser_error").hide();
                    } else {
                        $("#old_browser_error").hide();
                        $("#supported_browser_error").show();
                    }

                    $( "#error_dialog" ).dialog({
                        autoOpen: true,
                        modal: true,
                        title: global_helper.error_dialog_title,
                        width: 550,
                        buttons: [
                            {
                                text: "Refresh",
                                id: "button_refresh",
                                click: function() {
                                    // Reload the current page
                                    $( this ).dialog( "close" );
                                    location.reload(true);
                                }
                            },
                            {
                                text: "Home",
                                id: "button_home",
                                click: function() {
                                    // Take the user somewhere else
                                    $( this ).dialog( "close" );
                                    window.location = "/";
                                }
                            },
                            {
                                text: "Close",
                                id: "button_close",
                                click: function() {
                                    // Close the dialog and keep going
                                    $( this ).dialog( "close" );
                                }
                            }
                        ],
                        open: function() {
                            $("#button_refresh").button({icons: {primary: "ui-icon-refresh"}});
                            $("#button_home").button({icons: {primary: "ui-icon-home"}});
                            $("#button_close").button({icons: {primary: "ui-icon-close"}});
                        }
                    });
                } catch(e) {
                    /* If we got an error trying to show the error dialog,
                     * we don't want to show any more errors, so just eat it.
                     */
                     window.console && console.log && console.log(e);
                }
            }
        },

        /* get_key_value_pairs:
         * Retrieve key/value pairs as an object
         *
         * @param {type} search_str: The whole string to search on (e.g. "foo=1&bar=2&baz=3")
         * @param {type} pair_separator (e.g. "&"). Defaults to regex /&amp;|&/
         * @param {type} kv_separator (e.g. "="). Defaults to '='.
         * @returns {Object} : the key value pairs
         */
        get_key_value_pairs : function(search_str, pair_separator, kv_separator, is_uri) {
            var value = "";
            // IE8 split/iterate does bad things on empty strings
            if ( global_helper.blank( search_str ) ) {
                return value;
            }

            if( kv_separator === undefined ) {
                kv_separator = '=';
            }
            
            if( pair_separator === undefined ) {
                pair_separator = /&amp;|&/;
            }

            if( is_uri === undefined ) {
                is_uri = true;
            }

            var search_str_big_arr = search_str.split(pair_separator);
            var search_str_arr = {};

            for(var k=0, len=search_str_big_arr.length; k<len; k++) {
                if( search_str_big_arr[k] !== undefined) {
                    var search_str_small_arr = search_str_big_arr[k].split(kv_separator);
                    if(search_str_small_arr.length === 2) {
                        // Got a valid chunk of stuff
                        if (is_uri) {
                            search_str_arr[search_str_small_arr[0]] = decodeURIComponent(search_str_small_arr[1]);
                        } else {
                            search_str_arr[search_str_small_arr[0]] = search_str_small_arr[1];
                        }
                        
                    }
                }
            }

            return search_str_arr;
        },

        /* get_value_from_key_value_pairs:
         * Retrieve one key from a set of key/value pairs
         *
         * @param {type} key: The thing we are looking for (e.g. "baz")
         * @param {type} search_str: The whole string to search on (e.g. "foo=1&bar=2&baz=3")
         * @param {type} pair_separator (e.g. "&"). Defaults to regex /&amp;|&/
         * @param {type} kv_separator (e.g. "=".). Defaults to '='.
         * @param {type} is_uri, defaults to true, triggers call to decodeURIComponent
         * @returns {String} : the value of the key we are looking for, or an empty string
         */
        get_value_from_key_value_pairs : function(key, search_str, pair_separator, kv_separator, is_uri) {
            var value = "";
            search_str_arr = global_helper.get_key_value_pairs(search_str, pair_separator, kv_separator, is_uri);

            if( search_str_arr[key] !== undefined) {
                value = search_str_arr[key];
            }

            return value;
        },


        /*
         * get_url_param:
         *      Get a specific parameter from the URL search string and return the decodeURIComponent value of it.
         */
        get_url_param : function(key) {
            return global_helper.get_value_from_key_value_pairs(key, window.location.search.substring(1));
        },

        /*
         * get_hash_param:
         *      Get a specific parameter from the URL hash string and return the decodeURIComponent value of it.
         */
        get_hash_param : function(key) {
            return global_helper.get_value_from_key_value_pairs(key, window.location.hash.replace("#!", ""));
        },

        /*
         *  client_logger:
         *  Log JS errors to the server so we can do something about them later.
         *
         *  to_log is an object that looks like this:
         *  {
         *      error_message:  errorMsg,
         *      error_file:     url,
         *      error_line:     lineNumber
         *  };
         */
        client_logger: function(to_log, error_type, callback, callback_data) {

            var log_error = true;

            if(Vspot.oldBrowser) {
                log_error = false;
            }

            if( typeof(to_log) === "undefined" ) {
                to_log = {}; // Empty object
            } else if( typeof(to_log) !== "object" ) {
                to_log = new Array(to_log);
            }

            if( typeof(error_type) === "undefined" ) {
                error_type = "Unspecified";
            }

            // Check for files to skip
            if( log_error &&  typeof( to_log.error_file ) !== "undefined" ) {
                $.each(global_helper.ignore_files, function(k,v) {
                    var pattern = new RegExp(v, "i");
                    if( pattern.test( to_log.error_file.toLowerCase() ) !== false ) {
                        // It's a file we don't care about
                        log_error = false;
                        return false; // Break out of the loop
                    }
                });
            }

            // Check for files to skip, not found in error_file
            if( log_error && typeof( to_log.error_line ) !== "undefined" && typeof( to_log.error_line ) === "string" ) {
                $.each(global_helper.ignore_lines, function(k,v) {
                    var pattern = new RegExp(v, "i");
                    if( pattern.test( to_log.error_line.toLowerCase() ) !== false ) {
                        // It's a message we don't care about
                        log_error = false;
                        return false; // Break out of the loop
                    }
                });
            }

            // Check for errors to skip
            if( log_error && typeof( to_log.error_message ) !== "undefined" ) {
                $.each(global_helper.ignore_errors, function(k,v) {
                    var pattern = new RegExp(v, "i");
                    if( pattern.test( to_log.error_message.toLowerCase() ) !== false ) {
                        // It's a message we don't care about
                        log_error = false;
                        return false; // Break out of the loop
                    }
                });
            }

            if( log_error ) {
                // Okay, to_log is now an array or object of some sort, and we should log it, so let's go...
                // Side note: Object.keys(x) will return an array of the keys... whether x is an Array or Object... so it's the right way to count length here.
                if( Object.keys(to_log).length > 0 ) {

                    var data = {
                        page_url:   document.URL
                    };

                    $.extend(data, to_log);

                    $.post("/api/logs",
                    {
                        to_log:     data,
                        error_type: error_type
                    },
                    function() {
                        // Whether or not the ajax call worked, we need to see if we should do a callback
                        if(typeof(callback) !== "undefined") {

                            if(typeof(callback_data) === "undefined"){
                                callback();
                            } else {
                                callback(callback_data);
                            }

                        }
                    });

                }
            }

            // Stick it in the console, if there is one
            if( typeof(console) !== "undefined" ) {
                console.log(to_log);
            }
        },
        /*
         * Formats an hour and minute, given in military time, to an AM/PM string.
         *
         * @param hour      The hour in military format
         * @param minute    The minute in military format
         * @returns {string} The formatted string
         */
        calculate_time: function(hour, minute) {
            var timeString = "",
                tHour, tMins, amPm;

            if (hour < 0) {
                timeString = '';
            } else {
                if (hour >= 12) {
                    tHour = hour - 12;
                    if (tHour == 0) tHour += 12;
                    amPm = 'pm';
                } else {
                    if ( hour == 0 ) {
                        hour = 12; // handle 12:30 am
                    }
                    tHour = hour;
                    amPm = 'am';
                }
                tMins = ((minute <= 9) ? '0' + minute : minute);
                timeString = tHour + ':' + tMins + amPm;
            }

            return timeString;
        },

        /*
         * open_new_window:
         *  url {str} - REQUIRED: url to open in the new window
         *  element {obj} - REQUIRED: element that was clicked
         *  debug {bool} - Are we printing out debugging data
         *  windowName {str} - name of the pop-up
         *  windowSpecs {str} - specs for the window
         */
        open_new_window: function(url, element, debug, windowName, windowSpecs) {
            /*
             * Turn html elements into pop-up links. There's no requirement that
             * it be an anchor tag.
             *
             * Links will need to have a class of "pop-up".
             *
             * You may control the parameters of the pop-up window by adding some
             * parameters to the link.
             *
             * Required Parameters:
             *  href or data-href - without this the link has no where to go. Relative paths seem to work fine.
             *  class - Must be set to "pop-up". Additional classes are fine.
             *
             *
             * Optional Parameters:
             *  debug - if set to "true", we'll do some debugging.
             *  window_name - The name for the window, one word, no dashes. "pop_up" is the default.
             *  window_specs - How you want the window to behave. The default is:
             *      "width=1200,height=900,location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,titlebar=no,toolbar=no"
             *      See here for more info:
             *      http://www.w3schools.com/jsref/met_win_open.asp
             *
             *      NOTE: top and left are automatically calculated. However, there is an obscure Chrome bug when the window
             *      is being opened on a second monitor. Chrome ignores top and left in this case.
             */

            if(url !== false) {
                debug && window.console && console.log && console.log("pop-up: Found a URL", url);

                // There's a URL, so deal with the window (otherwise we do nothing and assume there's some other JS to handle it)
                var open_new_window = true;
                var existing_window;
                if( element && element.data("pop-up") ) {
                    existing_window = element.data("pop-up");
                }
                

                if( existing_window !== undefined ) {
                    debug && window.console && console.log && console.log("pop-up: Found an existing window.");
                    if( existing_window.closed ){
                        debug && window.console && console.log && console.log("pop-up: Existing window is closed, blow it away.");
                        // The window is closed, blow it away and start over
                        element.data("pop-up", null);
                    } else {
                        debug && window.console && console.log && console.log("pop-up: Existing window is open, reuse it and bring to front.");
                        // There's and existing window
                        if( debug ) {
                            // Log some debugging data
                            window.console && console.log && console.log("pop-up: DEBUG: Would try to set existing window to:", url);
                        } else {
                            // Open the existing window
                            existing_window.location.href = url;
                            existing_window.focus();
                        }
                        open_new_window = false;
                    }
                }

                if(open_new_window) {
                    debug && window.console && console.log && console.log("pop-up: Create a new window.");
                    // Open a new window
                    var name = windowName || "pop_up";
                    var specs = windowSpecs || "width=1200,height=900,location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,titlebar=no,toolbar=no";

                    // Dashes don't work in IE. Warn if console open, don't worry about debug param.
                    if( name.match(/-/g) ){
                        var old_name = name;
                        name = name.replace("-","_");
                        window.console && console.log && console.log("IE Doesn't support dashes in window names! Changing '" + old_name + "' to '" + name + "'.");
                    }

                    debug && window.console && console.log && console.log("pop-up: specs before: " + specs);

                    // Sould we figure out top and left?
                    if( !specs.match(/top=/gi) ) {
                        // Calculate top
                        var new_window_height = Vspot.global_helper.get_value_from_key_value_pairs("height", specs, ",", undefined, false);
                        var window_height = $(window).height();
                        if(window_height > new_window_height) {
                            // We can center vertically (not all browsers support, however)
                            var v_offset = (window_height - new_window_height)/2 + 50;
                            specs += ",top=" + v_offset;
                        }
                    }

                    if( !specs.match(/left=/gi) ) {
                        // Calculate left
                        var window_width = Vspot.global_helper.get_value_from_key_value_pairs("width", specs, ",", undefined, false);
                        var doc_width = $(window).width();
                        if(doc_width > window_width) {
                            // We can center horizontally
                            var h_offset = (doc_width - window_width)/2;
                            specs += ",left=" + h_offset;
                        }
                    }

                    debug && window.console && console.log && console.log("pop-up: name: " + name);
                    debug && window.console && console.log && console.log("pop-up: specs after: " + specs);

                    try {
                        var win = window.open(url, name, specs);
                        Vspot.lastOpenedWindow = win;
                        if( element ) {
                            element.data("pop-up", win); // Save it to the opening element
                        }
                        
                        // Bring the window to the front:
                        if(win) {
                            win.focus();
                        } else {
                            // Popup blocker... so just change the URL as a fall back
                            if( debug ) {
                                // Log some debugging data
                                window.console && console.log && console.log("pop-up: DEBUG: Would try to redirect to:", url);
                            } else {
                                // Go to the url
                                window.location.href = url;
                            }
                        }
                    }
                    catch(e) {
                        // Pop-up blocker? Eat the error
                        debug && window.console && console.log && console.log("pop-up error:", e);
                        // Hopefully this will work:
                        if( debug ) {
                            // Log some debugging data
                            window.console && console.log && console.log("pop-up: DEBUG: Would try to redirect to:", url);
                        } else {
                            // Go to the url
                            window.location.href = url;
                        }
                    }
                }

                return false;
            } else if(debug) {
                // Make sure the link doesn't go anywhere
                window.console && console.log && console.log("A pop-up link was clicked, but it doesn't have an href parameter.");
                return false;
            }
        },

        /*
         * is_html_element:
         *      This function takes an object and trys to determine if it's an HTML element.
         *
         * Borrowed from: http://stackoverflow.com/questions/384286/javascript-isdom-how-do-you-check-if-a-javascript-object-is-a-dom-object
         */
        is_html_element: function(obj) {
            try {
                //Using W3 DOM2 (works for FF, Opera and Chrom)
                return obj instanceof HTMLElement;
            }
            catch(e){
                //Browsers not supporting W3 DOM2 don't have HTMLElement and
                //an exception is thrown and we end up here. Testing some
                //properties that all elements have. (works on IE7)
                return (typeof obj==="object") &&
                    (obj.nodeType===1) && (typeof obj.style === "object") &&
                    (typeof obj.ownerDocument ==="object");
            }
        },

        /*
         * blank:
         *      This function is trying to mimic the Rails .blank? function.
         *      Blank constitutes: false, empty, or a whitespace string
         *
         *      Things that should return true:
         *          global_helper.blank(undefined)
         *          global_helper.blank(null)
         *          global_helper.blank('')
         *          global_helper.blank(' ')
         *          global_helper.blank('    ')
         *          global_helper.blank(0)
         *          global_helper.blank(000000)
         *          global_helper.blank([])
         *          global_helper.blank({})
         *          global_helper.blank(NaN)
         *
         *      Things that should return false:
         *          global_helper.blank(9)
         *          global_helper.blank(['foo'])
         *          global_helper.blank({'foo': 'bar'})
         *          global_helper.blank('    alskdfj')
         *          global_helper.blank( function() {...} )
         */
        blank: function(item) {
            var blank = false;

            if( item === undefined || item === null || item === false || item !== item ) { // last one is a NaN check
                blank = true;
            } else if( global_helper.is_html_element(item) ) {
                /* NOTE: This worked in the test case for which it was added.
                 * That is, dragging and dropping an HTML element for which 
                 * item.constructor returned different things in differnt browsers
                 * below. But, I'm not convinced that there couldn't be a situation
                 * where is_html_element() returns true but $(item).length is
                 * zero, and in that case we might not want to consider the element
                 * blank. Just something to think about if getting unexpected results.
                 */
                if( !$(item).length ) {
                    // This means it IS an HTML element, but jQuery can't find it
                    blank = true;
                }
            } else if( typeof(item) === 'function' ){
                // Assume that functions are not empty... even if they don't do anything.
                blank = false;
            } else {
                // Check for special cases
                switch( item.constructor ) {
                    case Array:
                        // Check for zero-length array
                        if( item.length === 0 ) {
                            blank = true;
                        }
                        break;

                    case String:
                        // Check for an empty string, or only whitespace
                        if( item.trim().length === 0 ) {
                            blank = true;
                        }
                        break;

                    case Number:
                        // Check for zero
                        if( item === 0 ) {
                            blank = true;
                        }
                        break;

                    case Object:
                        // Object has no properties
                        if( Object.keys(item).length === 0 ) {
                            blank = true;
                        }
                        break;

                    default:
                        // Let's see if it's a DOM element
                        if( !$(item).length ) {
                            // Either it's now an empty jQuery object, or jQuery couldn't parse it
                            window.console && console.log && console.log("global_helper::blank() did not have a way to handle this item. Since something was sent in, the default is to assume it is NOT blank. Item in question:", item, item.constructor );
                        }
                        
                }
            }
            return blank;
        },

        /*
        * Convert the extra fields from what the angular form wants (date object, integer, object for multivalued)
        * to strings to save on the back end. Used when saving from an angular form to the server
        *
        * @param val: the value (string, date object, array of checkboxes)
        * @param format: what the type of val is, in extra-field-definition language
        * @param rootScope: where to find vspotFormatDate, generally $scope.$root
        */
        serializeExtraField: function(val,format,rootScope) {
            if( val ) {

                var newVal;
                if (val) {
                    switch (format) {
                        case 'date':
                            newVal = rootScope.vspotFormatDate(val,'api');// val.toString();
                            break;
                        case 'checkbox':
                            var checkedBoxes = [];
                            for (var key in val) {
                                if (val[key]) checkedBoxes.push(key);
                            }

                            newVal = checkedBoxes.join(',');
                            break;
                        case 'number':
                            newVal = parseInt(val, 10); // force everything to a number (firefox allows text in number fields)
                            break;
                        default:
                            newVal = val;
                    }
                }
                return newVal;
            } else {
                return val;
            }
        },
        /*
         * De-serialize the extra field value from the back end into something angular can bind to in
         * the user extra fields forms. I.e. undo what was done above.
         *
         * Checkbox is the trickiest, it starts as a list of checked items (i.e. a,b,c) and the complete
         * list is in the definition (i.e. a,b,c,d,e,f).
         */
        deserializeExtraField: function(val,format,definitionValues) {
            var newVal;
            if (val) {
                switch (format) {
                    case 'date':
                        // PWD: hard to believe but the best way to parse a date (without timezone) is to split it ourselves?!?
                        // so handle YYYY-MM-DD and YYYY/MM/DD
                        if (val) {
                            var pieces = val.split(/[-\/]/);
                            newVal = new Date( pieces[0],pieces[1]-1,pieces[2]); // Date.parse( val ) );
                        }
                        break;
                    case 'number':
                        newVal = parseInt(val);
                        break;
                    case 'checkbox':
                        var checkboxNames = definitionValues || [],
                         checkboxesSet = val.split(','),
                         extraFieldValues = {};
                        var checkboxesArray = checkboxNames.split(',');
                        for( var g=0; g<checkboxesArray.length; g++ ) {
                            extraFieldValues[checkboxesArray[g]] = checkboxesSet.includes(checkboxesArray[g]) ? true : false;
                        }
                        newVal = extraFieldValues;
                        break;
                    default:
                        newVal = val;
                }
            }
            return newVal;
        }

    };
})(jQuery);

return root.global_helper = global_helper;
  }).apply(root, arguments);
});
}(this));

